export enum LockableEntities {
  ROLE = 'Role',
}
